import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full">
        <div className="flex items-center justify-between px-4 md:px-8 h-16 max-w-full">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span
              className={`font-bold text-xl font-heading ${
                scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              汗汗漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {[
              { path: '/', label: '首页' },
              { path: '/category/all', label: '分类' },
              { path: '/about', label: '关于我们' },
            ].map((item) => {
              const isActive = item.path === '/'
                ? location.pathname === '/'
                : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? scrolled || !isHome
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-background-50/20 text-background-50'
                      : scrolled || !isHome
                        ? 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                        : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`relative ${scrolled || !isHome ? '' : 'text-background-50'}`}>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`pl-9 pr-4 py-2 text-sm rounded-full border outline-none transition-all w-48 focus:w-64 ${
                  scrolled || !isHome
                    ? 'bg-background-100 border-background-200 text-foreground-950 placeholder-foreground-400 focus:border-primary-300'
                    : 'bg-background-50/10 border-background-50/20 text-background-50 placeholder-background-50/50 focus:border-background-50/50'
                }`}
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-sm"></i>
            </div>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            } cursor-pointer`}
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200 animate-slide-down">
            <div className="p-4 space-y-1">
              {[
                { path: '/', label: '首页' },
                { path: '/category/all', label: '分类浏览' },
                { path: '/about', label: '关于我们' },
              ].map((item) => {
                const isActive = item.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(item.path);
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`}
                  >
                    {item.label}
                  </Link>
                );
              })}
              <div className="px-4 pt-3">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索漫画..."
                    className="pl-9 pr-4 py-2.5 text-sm rounded-full border border-background-200 bg-background-100 text-foreground-950 placeholder-foreground-400 outline-none focus:border-primary-300 w-full"
                  />
                  <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}